export default __webpack_public_path__ + "static/media/transact-arrow.b91e3641.svg";